// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"230":"component---src-pages-index-jsx","256":"component---src-pages-404-jsx","351":"commons"}[chunkId] || chunkId) + "-" + {"230":"4f10bedfaa47fb989740","256":"1e11fa83fdfd3633de04","351":"041f10443f42b7203898","731":"b89d8d875bdff01f2d39","843":"ed7fbc5666626b61925a"}[chunkId] + ".js";
};